import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { config } from "../config";

// Define a service using a base URL and expected endpoints
export const profileApi = createApi({
  reducerPath: "profileApi",
  baseQuery: fetchBaseQuery({
    baseUrl: config.base_url,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("token");
      // console.log("token :: ", token);
      headers.set("Access-Control-Allow-Origin", "*");
      if (token !== "" && token !== undefined) {
        headers.set("Authorization", "Bearer " + token);
      }
      //   headers.set("Content-Type", "multipart/form-data;");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    signupUser: builder.mutation({
      query: (userData) => {
        // console.log("signUpPage :: userData :: ", userData);
        const formData = new FormData();
        formData.append("full_name", userData.full_name);
        formData.append("email", userData.email);
        formData.append("password", userData.password);
        formData.append("country", userData.country);
        formData.append("profile_image", userData.profile_image[0]);
        formData.append("device", navigator.userAgent);
        formData.append("os", navigator.platform);
        return {
          url: "/sign-up",
          method: "post",
          body: formData,
          prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("token");
            headers.set("Access-Control-Allow-Origin", "*");
            // headers.set("Authorization", "Bearer " + token);
            headers.set("Content-Type", "multipart/form-data;");
            return headers;
          },
        };
      },
    }),
    profileUpdate: builder.mutation({
      query: (data) => {
        // console.log("profileUpdate :: data  ::", data);

        const formData1 = new FormData();
        formData1.append("full_name", data?.full_name);
        formData1.append("country", data?.country);
        formData1.append("profile_image", data?.profile_image[0]);
        formData1.append("about", data?.about);
        // console.log("profileUpdate :: formData1  ::", formData1);

        return {
          url: "/update-profile",
          method: "post",
          body: formData1,
        };
      },
    }),
    changePassword: builder.mutation({
      query: (data) => {
        const changePasswordFormData = new FormData();
        changePasswordFormData.append("current_password", data.current_password);
        changePasswordFormData.append("password", data.password);

        return {
          url: "/change-password",
          method: "post",
          body: changePasswordFormData,
        };
      },
    }),
    deleteAccount: builder.mutation({ query: () => "/account-delete" }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useSignupUserMutation, useProfileUpdateMutation, useChangePasswordMutation, useDeleteAccountMutation } = profileApi;
